import styled, { css } from "styled-components"

export const Signature = styled.div`
	display: flex;
	flex-direction: column;
	flex: 1;

	@media only screen and (min-width: 601px) {
		background-color: #F5F5F5;
	}

	@media only screen and (max-width: 1000px) {
		background-color: white;
	}
`

Signature.SignaturePad = {}

Signature.SignaturePad.InputContainer = styled.div`
	width: 100%;
	height: 150px;
	border: 1px solid #D9E1E8;
	border-radius: 8px;
	position: relative;
	overflow: hidden;
	background-color: white;
`

Signature.SignaturePad.TextArea = styled.textarea`
	width: 100%;
	height: 150px;
	color: #000 !important;
	border: none;
	border-radius: 0;
	text-align: center;
	font-family: Satisfy, cursive !important;
	font-size: 35px !important;
	font-style: normal;
	resize: none !important;
	padding: 16px 8px !important;
	box-sizing: border-box;
	line-height: 40px !important;
`

export const SignatureCanvasContainer = styled.div`
	width: 100%;
	height: 150px;
	border: 1px solid #D9E1E8;
	border-radius: 8px;
	background-color: white;
	overflow: hidden;

	.sigCanvas {
		width: 100% !important;
		height: 100% !important;
	}
`

export const SignatureTypeWrapper = styled.div`
	display: flex;
	margin: 8px 0;
`

const activeStyle = css`
	background-color: #E6F2FF;
	color: #005299;
	border: 1px solid #007BFF;
`

const inactiveStyle = css`
	background-color: white;
	color: #000;
	border: 1px solid #D0D5DD;
`

export const SignatureTypeButton = styled.div`
	display: flex;
	align-items: center;
	gap: 8px;
	padding: 3px 16px;
	font-size: 14px;
	border-radius: 9999px;
	cursor: pointer;
	${props => props.active ? activeStyle : inactiveStyle}
	&:not(:last-child) {
		margin-right: 8px;
	}
`
